import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6999e93df782d50014ecdc4b/myhappyplacedigital/node_modules/next/dist/client/app-dir/link.js");
